import { Hidden, makeStyles } from '@material-ui/core';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { FullScreenDialog } from 'components/FullScreenDialog/FullScreenDialog';
import { Icon } from 'components/Icon/Icon';
import React, { ReactElement } from 'react';
import { VendorMenu } from './VendorMenu';
import { ReactComponent as CloseIcon } from 'assets/icons/main-16/times--16.svg';

export interface VendorMenuDialogProps {
    onClose: () => void;
    children?: ReactElement;
}

const useDialogStyles = makeStyles(theme => ({
    container: {
        background: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    close: {
        position: 'absolute',
        left: -72,
        top: 24,
        width: 48,
        height: 48,
        borderRadius: '100%',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    menu: {
        position: 'relative',
        background: '#fff',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 400,
        },
    },
    vendorMenu: {
        height: '100%',
        [theme.breakpoints.down('xs')]: {
            paddingBottom: 56,
        },
    },
}));

export const VendorMenuDialog = (props: VendorMenuDialogProps) => {
    const classes = useDialogStyles();
    const { onClose } = props;
    return (
        <ErrorBoundary>
            <FullScreenDialog onClose={onClose} className={classes.container}>
                {({ onClose }) => (
                    <div className={classes.menu}>
                        <Hidden xsDown>
                            <div className={classes.close} onClick={onClose}>
                                <Icon component={CloseIcon} size={16} svgSize={16} />
                            </div>
                        </Hidden>
                        <div className={classes.vendorMenu}>
                            <VendorMenu />
                        </div>
                        {props.children}
                    </div>
                )}
            </FullScreenDialog>
        </ErrorBoundary>
    );
};
